import {Match} from "models/Match.jsx";
import { Users } from 'models/UserCollection';
import {Request} from "./Request";
import { openPage } from 'navigation/pageLocation';
import React from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';
import HistorySetList from 'react/matchHistoryPopup/HistorySetList';

$(function(){
   if($('#advanced-match-history').length)
   {
       let matchHistoryCalendar = new AdvancedMatchHistory();
   }
});
class AdvancedMatchHistory{


    constructor(){
        var matchCalendar = $('#match_calendar');
        var currentPlayerId = matchCalendar.data('player_id');
        // $('.month_display .month').click(function (e) {
        //     if (e.which == 2) {
        //         return true;
        //     }
        //     e.preventDefault();
        //     var month = $(this).find('input[name=month]').val() - 1;
        //     var year = $(this).find('input[name=year]').val();
        //     matchCalendar.fullCalendar('gotoDate', year, month);
        // });
        var request = null;
        matchCalendar.fullCalendar({
            events: function (start, end, timezone, callback) {
                if (request && request.xhrRequest) {
                    request.xhrRequest.abort();
                }
                var data = {};
                data.player_id = currentPlayerId;
                data.start = start.unix();
                data.end = end.unix();
                var calendarContainer = $('.calendar_container');
                calendarContainer.addClass('loading');
                var matchList = $('.listed_matches_container');
                request = Request.apiv1Get('match/history', data).then((response)=>{
                    var listedFriendlies = 0;
                    var listedRanked = 0;
                    var events = response.events;
                    calendarContainer.removeClass('loading');
                    if (response.events && !response.events.length) {
                        $('.listed_matches').hide();
                        $('.no_results').show();
                        $('.total_count').hide();
                    }
                    else {
                        $('.no_results').hide();
                        $('.listed_matches').show();
                        $('.total_count').show().text('(' + response.events.length + ')');
                    }
                    $.each(events, function (i, event) {
                        var otherPlayer;
                        event.match = Match.retrieve(event.match);
                        event.other_player = Users.create(event.other_player);
                        var match = event.match;
                        if (event.match.player1.id == currentPlayerId) {
                            otherPlayer = event.match.player2;
                        }
                        else if (event.match.player2.id == currentPlayerId) {
                            otherPlayer = event.match.player1;
                        }

                        if (match.is_ranked) {
                            listedRanked++;
                            if (otherPlayer.won) {
                            }
                            else {
                            }
                        }
                        else {
                            listedFriendlies++;
                        }
                        event.start = moment.unix(event.start);
                        //							delete event.url;
                        delete event.backgroundColor;
                        delete event.textColor;
                    })

                    var listedResults = $('.listed_result_summary').addClass('active');
                    listedResults.find('.friendlies').find('.count').text(listedFriendlies);
                    listedResults.find('.ranked').find('.count').text(listedRanked);
                    // The listed sets, newest first, as match history rows.
                    renderIntoContainer(
                        <HistorySetList matches={(response.matches || []).map((matchData) => Match.create(matchData))} player={{ id: currentPlayerId }} />,
                        matchList.find('.match_results')[0],
                    );
                    callback(response.events);
                }, Request.generalJsonError);
            },
            eventLimit: true,
            views: {
                agenda: {}
            },
            // viewRender: function(view) {
            // var date = $('#match_calendar').fullCalendar('getDate');
            // var year = date.getFullYear();
            // var month = date.getMonth();
            // var day = date.getDay();
            //
            // var $found = $('input[name="year/month"][value="'+year+'/'+(month+1)+'"]').closest('.month');
            // $('.month_display .month').removeClass('selected');
            // if($found.length)
            // {
            // $found.addClass('selected');
            // }
            // },
            eventRender: function (event, element, view) {
                var match = event.match;

                var content = element.find('.fc-content');
                var title = element.find('.fc-title');

                title.addClass('username_formatted');

                var user = event.other_player.createUsernameElement();
                title.empty();
                title.append(user).append(' ').append(event.start.format('h:mma'));
                if (match.is_ranked) {
                    element.addClass('ranked');
                }
                else {
                    element.addClass('unranked');
                }

                element.find('.fc-time').remove();
                element.attr('title', event.hover);
                element.click(function (e) {
                    e.preventDefault();
                    openPage(element.attr('href'));
                });
                if (match.ladder) {
                    element.addClass('game-' + match.ladder.slug);
                }

                var image = $('<img>').attr('src', event.game_url).addClass('calendar_logo').prependTo(content);
                /*element.tooltip();*/
            }
        });
    }
}